import React from 'react';
import { useState } from 'react';
import {
  Hidden,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import TimecardDatasheetWeek from './TimecardDatasheetWeek';
import { useEffect } from 'react';
import {
  getProcHoursBreakdown,
  getClockedHoursTotal,
  sumProperty,
} from '../../util/helperFunctions';
import dateUtil from '../../util/dateUtil';
import Visible from '../../components/Visible';

const styles = makeStyles((theme) => ({
  headerRow: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  totalRow: {
    backgroundColor: theme.palette.background.paper,
  },
  dayColumn: {
    minWidth: '240px',
    [theme.breakpoints.down('xs')]: {
      minWidth: 'inherit',
    },
  },
  table: {
    ' & .MuiTableCell-sizeSmall': { padding: 6 },
    ' & input': { textAlign: 'right' },
  },
}));

const TimecardDatasheet = ({ timecard, disabled }) => {
  const classes = styles();
  const [localWorkdays, setLocalWorkdays] = useState();
  useEffect(() => {
    if (timecard?.workdays?.length) {
      const tempWorkdays = JSON.parse(JSON.stringify(timecard.workdays));
      tempWorkdays.forEach((workday) => {
        const workdayEntries = timecard.entries.filter((entry) =>
          dateUtil.isSameDay(entry.startDate, workday.workDate)
        );
        const { serviceHours } = getProcHoursBreakdown(workdayEntries);
        const clockedHours = getClockedHoursTotal(workday);
        workday.serviceHours = serviceHours;
        workday.clockedHours = clockedHours;
      });
      setLocalWorkdays(tempWorkdays);
    }
  }, [timecard]);
  const saveUpdate = (row, column, value) => {
    const tempLocalWorkdays = JSON.parse(JSON.stringify(localWorkdays));
    const dayToUpdate = tempLocalWorkdays.find((r) => r.id === row.id);
    dayToUpdate[column] = value;
    const clockedHours = getClockedHoursTotal(dayToUpdate);
    dayToUpdate.clockedHours = clockedHours;
    setLocalWorkdays(tempLocalWorkdays);
    return dayToUpdate;
  };

  if (!timecard) return '';

  const TotalCell = ({ value, padding }) => {
    return (
      <TableCell align="right" style={{ paddingRight: padding || 33 }}>
        <Typography>{Number.parseFloat(value).toFixed(2)}</Typography>
      </TableCell>
    );
  };

  return localWorkdays ? (
    <Table size="small" className={classes.table}>
      <TableBody>
        <TimecardDatasheetWeek
          days={localWorkdays.slice(0, 7)}
          saveUpdate={saveUpdate}
          disabled={disabled}
        />
        <TimecardDatasheetWeek
          days={localWorkdays.slice(7, 14)}
          saveUpdate={saveUpdate}
          disabled={disabled}
        />
        <TableRow className={classes.totalRow} style={{ backgroundColor: 'e9f1fd' }}>
          <TableCell component="th" scope="row" align="right">
            <Typography className={classes.headerRow}>Period Totals</Typography>
          </TableCell>
          <Visible mdUp>
            <TotalCell value={sumProperty(localWorkdays, 'workHours')} />
            <TotalCell value={sumProperty(localWorkdays, 'sickhours')} />
            <TotalCell value={sumProperty(localWorkdays, 'vacationHours')} />
            <TotalCell value={sumProperty(localWorkdays, 'holidayHours')} />
            <TotalCell value={sumProperty(localWorkdays, 'clockedHours')} padding={6} />
            <TotalCell value={sumProperty(localWorkdays, 'serviceHours')} padding={6} />
            <TotalCell
              padding={6}
              value={
                Number.parseFloat(sumProperty(localWorkdays, 'bonusHours')) +
                Number.parseFloat(sumProperty(localWorkdays, 'bonusHoursOver38'))
              }
            />
          </Visible>
          <Visible only="sm">
            <TotalCell value={sumProperty(localWorkdays, 'workHours')} padding={32} />
            <TotalCell value={sumProperty(localWorkdays, 'sickhours')} padding={32} />
            <TotalCell value={sumProperty(localWorkdays, 'vacationHours')} padding={32} />
            <TotalCell value={sumProperty(localWorkdays, 'holidayHours')} padding={32} />
          </Visible>
          <Visible only="xs">
            <TotalCell value={sumProperty(localWorkdays, 'workHours')} padding={17} />
            <TotalCell value={sumProperty(localWorkdays, 'sickhours')} padding={17} />
            <TotalCell value={sumProperty(localWorkdays, 'vacationHours')} padding={17} />
            <TotalCell value={sumProperty(localWorkdays, 'holidayHours')} padding={17} />
          </Visible>
        </TableRow>
      </TableBody>
    </Table>
  ) : (
    ''
  );
};

export default TimecardDatasheet;
